module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-checkbox"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-demo-wrapper"
  }, [_c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-checkbox', {
    model: {
      value: (_vm.checkbox1),
      callback: function($$v) {
        _vm.checkbox1 = $$v
      }
    }
  }, [_vm._v("复选框1")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("禁用状态")]), _vm._v(" "), _c('zan-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.checkbox2),
      callback: function($$v) {
        _vm.checkbox2 = $$v
      }
    }
  }, [_vm._v("复选框2")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("Checkbox组")]), _vm._v(" "), _c('zan-checkbox-group', {
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      }
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('zan-checkbox', {
      attrs: {
        "name": item
      }
    }, [_vm._v("复选框" + _vm._s(item))])
  })), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("禁用Checkbox组")]), _vm._v(" "), _c('zan-checkbox-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      }
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('zan-checkbox', {
      attrs: {
        "name": item
      }
    }, [_vm._v("复选框" + _vm._s(item))])
  })), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("与Cell组件一起使用")])], 1), _vm._v(" "), _c('zan-checkbox-group', {
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      }
    }
  }, [_c('zan-cell-group', _vm._l((_vm.list), function(item) {
    return _c('zan-cell', [_c('zan-checkbox', {
      attrs: {
        "name": item
      }
    }, [_vm._v("复选框" + _vm._s(item))])], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42176c3e!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/checkbox.vue
// module id = 288
// module chunks = 0